<template>
  <div>
    Hello World
  </div>
</template>

<script>
import ActivityManager from 'mixins/ActivityManager';
import AssetLoader from 'mixins/AssetLoader';
import ErrorLogger from 'mixins/ErrorLogger';
import TypingActivityHelper from 'mixins/TypingActivityHelper';

export default {
  mixins: [AssetLoader, TypingActivityHelper, ActivityManager, ErrorLogger]
};
</script>

<style lang="scss" scoped></style>
